import { ShapeClipboard }        from '@tokamap/core';
import { ShapeClipboardContent } from '@tokamap/core';

/**
 * Presse-papier de formes partagé par les cartes d'un même projet : chaque carte est montée dans sa
 * propre instance `@tokamap/core` (voir `<Map key={map.id}>`), dont le presse-papier interne
 * disparaîtrait au changement de carte.
 *
 * Le contenu ne se colle que dans le projet d'où il a été copié : ailleurs, le presse-papier paraît
 * vide (menu « Coller » grisé, Ctrl+V sans effet).
 */
class ShapeClipboardStore {
	private _copied: { projectId: string; content: ShapeClipboardContent } | null = null;

	/** Presse-papier à donner à l'instance de la carte `mapUrn` du projet `projectId`. */
	forMap(projectId: id, mapUrn: string): ShapeClipboard {
		return {
			origin: mapUrn,
			read: () => (this._copied?.projectId === String(projectId) ? this._copied.content : null),
			write: content => {
				this._copied = { projectId: String(projectId), content };
			},
		};
	}
}

export default new ShapeClipboardStore();
